import { render, staticRenderFns } from "./ui-area.vue?vue&type=template&id=7f6fa0d6&"
import script from "./ui-area.vue?vue&type=script&lang=js&"
export * from "./ui-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports